//import { TimelineMax, Power4 } from 'gsap/all';
import { TimelineLite } from 'gsap/TimelineLite';
import { Power4 } from 'gsap/TweenLite';
// import { TweenLite, Power4 } from 'gsap/src/minified/TweenLite.min.js';
// import { default as TimelineLite } from 'gsap/src/minified/TimelineLite.min.js';
import 'gsap/CSSPlugin';
// import 'gsap/src/minified/plugins/CSSPlugin.min.js';

import { each } from '../components/objects';

function change_styles(node, attrs) {
  if (node)
    for (let key in attrs)
      node.style[key] = attrs[key];
}

function add_class(nodes, class_name) {
  each(nodes, function(_, el) {
    el.classList.add(class_name);
  });
}

function remove_class(nodes, class_name) {
  each(nodes, function(_, el) {
    el.classList.remove(class_name);
  });
}

function show_menu_for_mobile() {
  const tl = new TimelineLite();
  
  // background
  tl.to('.menu__ul--cover', 0.2, {
    display: 'block',
    opacity: 1,
    ease: Power4.easeInOut,
  });

  // menu
  tl.to('.menu__ul--mobile', 0.2, {
    display: 'flex',
    opacity: 1,
    transform: `translateY(calc(50vh - 72px))`, // 72px is the height of the nav
  }, 0.2);
  
  change_styles(document.body, {'overflow-y': 'hidden'});
  add_class(document.querySelectorAll('.menu__bars'), 'opened');
}

function hide_menu_for_mobile() {
  const tl = new TimelineLite();
  
  // menu
  tl.to('.menu__ul--mobile', 0.2, {
    display: 'none',
    opacity: 0,
    transform: `translateY(35vh) rotateX(-35deg)`,
  });

  // background
  tl.to('.menu__ul--cover', 0.2, {
    display: 'none',
    opacity: 0,
    ease: Power4.easeInOut,
  }, 0.2);
  
  change_styles(document.body, {'overflow-y': 'auto'});
  remove_class(document.querySelectorAll('.menu__bars'), 'opened');
}

// Handling window
function handleWindow() {
  const windowWidth = parseFloat(getComputedStyle(document.body, null).width.replace('px', ''));

  if (windowWidth <= 640) {
    document.querySelector('.menu__ul--desktop').style.display = 'none';
  } else {
    document.querySelector('.menu__ul--desktop').style.display = '';
    remove_class(document.querySelectorAll('.menu__bars'), 'opened');
    
    hide_menu_for_mobile();
  }
}

handleWindow();

window.addEventListener('load', handleWindow);
window.addEventListener('resize', handleWindow);

each(document.querySelectorAll('.menu__bars'), function(_, el) {
  el.addEventListener('click', function (e) {
    e.preventDefault();
    
    let menu = this;
    
    if (menu.classList.contains('opened')) {
      hide_menu_for_mobile();
    } else {
      show_menu_for_mobile();
    }
  });
});



// WEBPACK FOOTER //
// ./app/javascript/components_common/menu-animation.js